<template>
  <a
    @click.prevent="$emit('onClick', $event, lawCase);"
    @keydown="$emit('onKeydown', $event)"
    @blur="$emit('onBlur', $event)"
    :href="`${$store.state.appURL}${lawCase.slug}`"
    class="case"
  >
    {{ lawCase.content }}
  </a>
</template>

<script>
export default {
  props: {
    lawCase: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
  .case {
    @include padding(10px 16px);
    display: block;
    position: relative;
    transition: background-color .3s $ease-out-quart;
    color: color('text');
    font-family: var(--symplicy-font-secondary);
    font-size: rem(14px);
    line-height: (20 / 16);
    text-decoration: none;
    outline: none;

    @include mq($until: 'm') {
      @include padding(8px 10px);
      font-size: rem(13px);
    }

    &:focus,
    &:hover {
      z-index: 1;
      background-color: color('input-background');
    }
  }
</style>
